import { nFormatter } from "../../nFormatter";
import { pluralize } from "../../pluralize";
/**
 * min and max are strings because of the need to check for 0, and the possibility that min/max can come in as a
 * string or number, and if running Number(min) === 0 check, if min is an empty string itll equal true when
 * we want it to be false
 *
 * @param min - minimum value as string
 * @param max - maximum value as string
 * @param startWord - word that begins the chip statement
 * @param endWord - word that ends the chip statement
 * @param isPercent - optionally display percentsign
 * @returns string
 */
export var minMaxMessaging = function (min, max, startWord, endWord, isPercent) {
    var percentSign = isPercent ? "%" : "";
    var minAsNumber = Number(min);
    var maxAsNumber = Number(max);
    var minFormatted = nFormatter(minAsNumber);
    var maxFormatted = nFormatter(maxAsNumber);
    if (!min && min !== "0" && !max && max !== "0") {
        return null;
    }
    else if (!min && min !== "0") {
        return "".concat(startWord, " less than ").concat(maxFormatted).concat(percentSign, " ").concat(endWord).concat(pluralize("", "s", !isPercent ? maxAsNumber : 2));
    }
    else if (!max && max !== "0") {
        return "".concat(startWord, " more than ").concat(minFormatted).concat(percentSign, " ").concat(endWord).concat(pluralize("", "s", !isPercent ? minAsNumber : 2));
    }
    else if (min === max) {
        return "".concat(startWord, " ").concat(maxFormatted).concat(percentSign, " ").concat(endWord).concat(pluralize("", "s", !isPercent ? maxAsNumber : 2));
    }
    else {
        return "".concat(startWord, " ").concat(minFormatted).concat(percentSign, "-").concat(maxFormatted).concat(percentSign, " ").concat(endWord).concat(pluralize("", "s", !isPercent ? maxAsNumber : 2));
    }
};
